export class HandlerType {
    public chat: boolean;
    public email: boolean;
    public both: boolean;
    public menuArbol: boolean;
}
